import styled from "styled-components";

export const Wrapper = styled.div`
  .login-button {
    width: 100% !important;
    background-color: #131f28;
    color: white;
  }

  .pagination-table {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 10px;
    padding-bottom: 10px;
  }


  .ant-select-selector {
    background-color: #131f28 !important;
    border: 1px solid #dddddd !important;
    margin-left: 10px;
    color: white !important;
  }

  .ant-select-arrow {
    color: white !important;
  }

 

  /* Set table width to auto */
  .ant-table {
    width: auto;
  }

  /* Set table container width to 100% */
  .ant-table-container {
    width: 100%;
  }

  /* Enable responsive behavior */
  @media (max-width: 992px) {
    overflow-x: auto;

    .ant-table-thead {
      min-width: fit-content;
    }
  }
`;

export const CustomStyles = {
  popoverContainer: {
    padding: 10,
    maxWidth: 200
  },
  popoverTitle: {
    fontSize: 10,
    fontWeight: 600
  },
  popoverBtnContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: 10
  },
  popoverBtn: {
    border: "none",
    background: "#131f28",
    color: "white",
    borderRadius: "5px"
  },
  container: {
    padding: 8,
    backgroundColor: "rgb(19, 31, 40)",
    color: "white",
  },
  sortOptions: {
    marginBottom: 8,
  },
  radio: {
    color: "white",
  },
  searchInput: {
    width: 188,
    marginBottom: 15,
    display: "block",
    borderRadius: 10,
  },
  checkboxOptions: {
    marginBottom: 15,
    maxHeight: 140, 
    overflowY: "auto",
    overflowX: "hidden",
    paddingRight: 8,

  },

  checkboxContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 5,
  },
  
  checkboxText: {
    marginRight: 8,
    color: "white",
  },
  applyButton: {
    width: 150,
    height: 26,
    border: "none",
    background: "rgb(58, 150, 184)",
    color: "white",
    borderRadius: 3,
    cursor: "pointer",
    fontSize: 14,
    outline: "none",
    border: "2px solid transparent",
  },
  reloadButtonContainer: {
    position: "relative",
  },
  reloadButton: {
    position: "absolute",
    top: -25,
    right: 0,
    width: 25,
    height: 25,
    background: "red",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  reloadIcon: {
    color: "white",
    fontSize: 16,
  },
  tagContainer: {
    display: 'inline-block',
    position: 'relative',
    marginTop: '2px',
  },
  tag: {
    color: '#131f28',
    width: '90%',
    textAlign: 'center',
    borderRadius: '70px',
    fontSize: '9px',
    position: 'relative',
    paddingLeft: '20px',
  },
  activeDot: {
    position: 'absolute',
    top: '50%',
    left: '0',
    transform: 'translateY(-50%)',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    zIndex: 1,
  },
  activeDotGreen: {
    backgroundColor: 'green',
    color: 'green',
  },
  activeDotRed: {
    backgroundColor: 'red',
    color: 'red',
  },
  inactiveDot: {
    position: 'absolute',
    top: '2.5px',
    left: '-3px',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#ccc',
    zIndex: 0,
  },

  filterSwitch: {
    paddingLeft: '0px',
    backgroundColor: 'black',
    color: 'green',
  },
}